<div class="card-content set-password-content">
  <h1 class="card-title">{{ 'set-password.title' | translate }}</h1>
  <form
    [formGroup]="setPasswordForm"
    (ngSubmit)="onSubmit()"
    class="set-password-form"
  >
    <div class="input-block">
      <label class="input-title input-text-required" for="password">{{
        'set-password.password' | translate
      }}</label>
      <div class="input-group input-btn-right">
        <input
          id="password"
          matInput
          [type]="isPasswordVisible ? 'text' : 'password'"
          formControlName="password"
          [ngClass]="{
            'input-error':
              showFormError && setPasswordForm.get('password')?.invalid,
          }"
          [placeholder]="'set-password.password-placeholder' | translate"
        />
        <button
          mat-icon-button
          type="button"
          (click)="togglePasswordVisibility()"
          class="input-password-btn"
        >
          <img
            [src]="
              isPasswordVisible
                ? 'assets/img/i-eye.svg'
                : 'assets/img/i-eye-closed.svg'
            "
            alt="toggle visibility"
          />
        </button>
      </div>
      <div class="input-warn-msg">
        @if (setPasswordForm.get('password')?.errors?.['length']) {
          <img
            width="16"
            height="16"
            ngSrc="/assets/img/i-check-disable.svg"
            alt=""
          />
        } @else {
          <img
            width="16"
            height="16"
            ngSrc="/assets/img/i-check-green.svg"
            alt=""
          />
        }
        <span>{{ 'set-password.password-hint1' | translate }}</span>
      </div>
      <div class="input-warn-msg">
        @if (setPasswordForm.get('password')?.errors?.['format']) {
          <img
            width="16"
            height="16"
            ngSrc="/assets/img/i-check-disable.svg"
            alt=""
          />
        } @else {
          <img
            width="16"
            height="16"
            ngSrc="/assets/img/i-check-green.svg"
            alt=""
          />
        }
        <span>{{ 'set-password.password-hint2' | translate }}</span>
      </div>
      <div class="input-warn-msg">
        @if (setPasswordForm.get('password')?.errors?.['specialChar']) {
          <img
            width="16"
            height="16"
            ngSrc="/assets/img/i-close-red.svg"
            alt=""
          />
        } @else {
          <img
            width="16"
            height="16"
            ngSrc="/assets/img/i-close-disable.svg"
            alt=""
          />
        }
        <span>{{ 'set-password.password-hint3' | translate }}</span>
      </div>

      <!--      @if (showFormError && setPasswordForm.get('password')?.invalid) {-->
      <!--        <mat-error  class="input-error-msg">{{ getPasswordErrorMessage() }}</mat-error>-->
      <!--      }-->
    </div>
    <div class="input-block">
      <label class="input-title input-text-required" for="re-enter-password">{{
        'set-password.re-enter-password' | translate
      }}</label>
      <div class="input-group input-btn-right">
        <input
          id="re-enter-password"
          matInput
          [type]="isReEnterPasswordVisible ? 'text' : 'password'"
          formControlName="reEnterPassword"
          [ngClass]="{
            'input-error':
              showFormError && setPasswordForm.get('reEnterPassword')?.invalid,
          }"
          [placeholder]="
            'set-password.re-enter-password-placeholder' | translate
          "
        />
        <button
          mat-icon-button
          type="button"
          (click)="toggleReEnterPasswordVisibility()"
          class="input-password-btn"
        >
          <img
            [src]="
              isReEnterPasswordVisible
                ? 'assets/img/i-eye.svg'
                : 'assets/img/i-eye-closed.svg'
            "
            alt="toggle visibility"
          />
        </button>
      </div>
      @if (showFormError && setPasswordForm.get('reEnterPassword')?.invalid) {
        <mat-error class="input-error-msg">{{
          getReEnterPasswordErrorMessage()
        }}</mat-error>
      }
    </div>
    <button mat-button type="submit" [disabled]="isProcessing" class="btn-fill-primary btn-size-l">
      {{ 'set-password.register' | translate }}
    </button>
    <!-- <span class="cancel-btn" (click)="goHome()">
      {{ 'common.button.cancel' | translate }}
    </span> -->
  </form>
</div>
